module.exports = __webpack_public_path__ + "static/sad-philoso-65f3c62c7b69c0399ad3a4651798bfed.svg";